import React from 'react';

import { SpecCourseLessonViewSectionContent } from 'common.components/spec-course-lesson-view/__section-content/spec-course-lesson-view__section-content';
import { SpecCourseLessonViewSection } from 'common.components/spec-course-lesson-view/__section/spec-course-lesson-view__section';

import { SpecCourseResultsTitle } from '../__title/results__title';
import { SpecCourseLessonViewStubInviteStudents } from '../../spec-course.lesson-view/__stub/lesson-view__stub_invite-students';

export const SpecCourseResultsInviteStudentsStub = () => {
    return (
        <SpecCourseLessonViewSection>
            <SpecCourseResultsTitle />
            <SpecCourseLessonViewSectionContent>
                <SpecCourseLessonViewStubInviteStudents />
            </SpecCourseLessonViewSectionContent>
        </SpecCourseLessonViewSection>
    );
};
